import { useQuery } from "@tanstack/react-query";
import * as modelApi from "../../../api/model";
import * as locationApi from "../../../api/location";

export function useLocationOptions() {
  return useQuery({
    queryKey: ["locationOptions"],
    queryFn: async () => {
      const locations = await locationApi.fetchAll();
      return locations.map((loc) => ({
        value: loc.id,
        name: loc.name,
      }));
    },
  });
}

export function useDayTypeOptions() {
  return useQuery({
    queryKey: ["dayTypeOptions"],
    queryFn: async () => {
      const info = await modelApi.fetchEnumMapping(null, "DayType");
      return info.mapping
        .filter((v) => v != null)
        .map((v) => ({ value: v.value, name: v.name }));
    },
  });
}
